import React from 'react'

export const OurGalleryHeader = () => {
  return (
    <div className="OurGalleryHeader">
      <div className="container">
        <div className="row">
            <div className="col-12">
                <h1>Our Gallery</h1>
                <p>It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently</p>
            </div>
        </div>
      </div>
    </div>
  )
}
